import {useFlags as useLDFlags} from 'launchdarkly-react-client-sdk';

export const useFlags = () => {
  const flags = useLDFlags();

  // Rename the LaunchDarkly flag names
  return {
    accountMfaRow: !!flags.accountMfaRow,
    areaQuotaReportIsActive: !!flags.accountAreaQuotaReports,
    oneClickProvisioningIsActive: !!flags.accountOneClickProvisioning,
    sentinelHubUserLinkingIsActive: !!flags.sentinelHubUserLinkingActive,
    selfServeQuotaReleaseIsActive: !!flags.accountSelfServeQuotaRelease,
  };
};

export default useFlags;
